import {APIClient} from "../base";

const ShipmentApi = {
    getAll: async () => await APIClient.get('/service-shipments', {}),
    getDetail: async (id: number|string|any) => await APIClient.get('/customer/' + id, {}),
    exportData: async () => await APIClient.get('/order/shipment-export', {}),
}

export default ShipmentApi;